import { render, staticRenderFns } from "./AddressModal.vue?vue&type=template&id=0fb17a86&"
import script from "./AddressModal.vue?vue&type=script&lang=js&"
export * from "./AddressModal.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/address/AddressModal/AddressModalStylePublic.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports